import { getLeaderboard, deleteChallenge } from 'api/challenges-v2'
import type { DeleteChallengeResponse, GetLeaderboardResponse } from 'api/types'
import { createApiThunk } from 'utils/thunkWrapper'

export const getChallengeLeaderboard = createApiThunk<GetLeaderboardResponse, ChallengeLeaderboardPayload>({
  action: 'challenge/leaderboard',
  request: (payload) => getLeaderboard(payload.challengeId),
})

export const deleteUserChallenge = createApiThunk<DeleteChallengeResponse, DeleteUserChallengePayload>({
  action: 'challenge/deleteUserChallenge',
  request: (payload) => deleteChallenge(payload.challengeId),
})
